<template>
  <div class="flex flex-col h-screen w-screen overflow-hidden bg-blueGray-100">
    <!-- 상단 영역 -->
    <admin-navbar class="fixed top-0 left-0 right-0 z-20 h-20" />

    <!-- 본문 영역 (상단 Navbar 80px 제외한 전체 영역) -->
    <div class="flex flex-row flex-1 pt-20 h-full overflow-hidden">
      <!-- 좌측 사이드바 -->
      <sidebar v-model="sidebarOpen" class="flex-shrink-0 z-10 h-full" />

      <!-- 우측 메인 영역 -->
      <div class="flex-1 flex flex-col h-full overflow-hidden bg-blueGray-100">
        <!-- 메뉴탭 헤더 -->
        <tab-header class="flex-shrink-0" />

        <!-- 본문 화면 영역 -->
        <div class="flex-1 overflow-x-auto overflow-y-auto px-2 bg-white">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

import AdminNavbar from "@/components/layouts/AdminNavbar.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import TabHeader from "@/components/layouts/TabHeader.vue";

const sidebarOpen = ref(true);
</script>
